// extracted by mini-css-extract-plugin
export default {"chip":"LabelChip_chip__--m8T","link":"LabelChip_link__UQQDb","closeBtn":"LabelChip_closeBtn__djLqP"};